module.exports = __webpack_public_path__ + "img/8a11468.jpg";